module.exports = __webpack_public_path__ + "img/75@3x.4d659259.png";